/**
 * @description 默认的页面layout， 大部分不需要定制的页面都可以用这个结构，不需要重写， 差异巨大去继承BasicLayout，否则一律继承这个
 * @author duanjun
 */

import BasicLayout from './basicLayout';
import { IData, IOptions } from './interface';
import version from './partial/version';
import renderSentryReportWithVersion from './partial/sentry';
import titlePart from './partial/title';
import reportPart from './partial/report';
import metaPart from './partial/meta';
import bootPart from './partial/boot';
import es6ShimPart from './partial/es6Shim';
import loadingPart from './partial/loading';
import analysisPart from './partial/analysis';
import monitorPart from './partial/monitor';
import debuggerPart from './partial/debugger';
import debuggerNodePart from './partial/debugger.node';
import reportSpyPart from './partial/reportSpy';
import wxSdk from './partial/wxSdk';
import qrcodeSdk from './partial/qrcode';
import captcha from './partial/captcha';
import iePolyfill from './partial/iePolyfill';
import isDesktop from './partial/isDesktop'

class NormalPageLayout<T extends IData = IData, K extends IOptions = IOptions> extends BasicLayout<T, K> {
    constructor(data: T, options: K) {
        super(data, options);
    }

    public renderTitle() {
        return titlePart();
    }

    public renderMeta() {
		if (this.data.RUN_TIME === 'node') {
			const metaStr = metaPart();
			return metaStr + '\n {{meta | default("") | safe}}';
		} else {
			return metaPart();
		}
    }

    /**
     * @description 不能留空格
     */
    public renderPageData() {
        if (this.data.RUN_TIME === 'node') {
            return `
                <script type="text/template" id="__pageDataTemplate__">{{pageData | jsonsafe}}</script>
            `;
        } else {
            return `
                <script type="text/template" id="__pageDataTemplate__"><?= json_encode($pageData) ?></script>
            `;
        }
    }

    public renderHeaderCss() {
        let cssPart = '{{source.globalCss | default("") | safe}}\n';
        this.options.css.forEach((path: string) => {
            cssPart += `<link href="${path}" rel="stylesheet" /> \n`;
        });
        return cssPart;
    }

    public renderFooterScript() {
        let scriptPart = '{{source.globalJs | default("") | safe}}\n';
        this.options.js.forEach((path) => {
            scriptPart += `<script type="text/javascript" src="${path}"></script> \n`;
        });
        return scriptPart;
    }

    public renderHeaderScript() {
        return '';
    }

    public setBodyClassName() {
        return `
            <script>
                if(window.isDesktop){
                    document.body.classList.add('is-pc')
                }
            </script>
        `
    }

    public renderHeader() {
        return `
            ${super.renderHeader()}
            ${this.renderTitle()}
            ${this.renderMeta()}
            ${this.renderHeaderCss()}
            ${iePolyfill()}
            ${this.renderHeaderScript()}
            ${bootPart(this.data)}
            ${this.data.RUN_TIME === 'node' ? debuggerNodePart() : debuggerPart()}
            ${this.useSentry ? renderSentryReportWithVersion(this.data, this.SYSTEM) : reportPart(this.data)}
            ${es6ShimPart(this.data)}
            ${wxSdk(this.data)}
            ${monitorPart(this.data)}
            ${isDesktop()}
        `;
    }

    public renderContent() {
        const data = this.data;
        return `<div class="doc ${data.pageClassName || ''}">
            ${loadingPart()}
        </div>`;
    }


    public renderFooter() {
        return `
            ${this.renderPageData()}
            ${qrcodeSdk(this.data)}
            ${this.renderFooterScript()}
            ${this.useSentry ? '' : reportSpyPart()}
            ${analysisPart(this.data)}
            ${version(this.data.VERSION)}
            ${captcha(this.data)}
        `;
    }

    public render() {
        return super.render();
    }
}

export default NormalPageLayout;
